import { configureStore} from '@reduxjs/toolkit';
import rootReducer from '../rootreducer/index'
const store = configureStore({reducer: rootReducer})
export default store; 